//axios
import axios from 'axios';
//utils
import { url } from 'utils/urls';

//headers
const withCredentials = true;
const headers = {
    "Content-Type": "application/json",
    'Accept': 'application/json',
};


export const asyncGetMigrationStatus = commentingUnitUUID => axios.get(`${url.ccu.base}/pub-portal/v1/commenting-units/${commentingUnitUUID}/migrate-status`, { headers, withCredentials });

export const asyncUpdateMigrationStatus = (commentingUnitUUID, status) => axios.put(`${url.ccu.base}/pub-portal/v1/commenting-units/${commentingUnitUUID}/migrate-status`, { status }, { headers, withCredentials });

export const asyncGetUpdatedCodes = (siteUUID) => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/commenting-units/add-ons/code?showOnlyNewCode=true`, { headers, withCredentials })